<template>
    <label>hhhhhhhhhhhhhhhh</label>
</template>
<script setup>
import axios from 'axios';
const props = defineProps(['productId','route','userId']);
const addToCart = async() =>{
    const productId = props.productId;
    const userId = props.userId;
    const qty = document.getElementById('qty').value;
    const response = await axios.post(props.route,{
        productId: productId,
        userId: userId,
        qty: parseInt(qty),
    });
    if(response.ok){
        window.successSnackbar("Product Added to cart");
    }
}
document.getElementById('add-to-cart-btn').addEventListener('click',addToCart)

</script>
